<template>
  <div class="advantage-container">
    <div class="title">{{$t('400107')}}</div>
    <div class="item-list">
      <div class="item">
        <img src="@/assets/img/feed.png" alt />
        <div class="item-title">{{$t('400108')}}</div>
        <div class="item-des">{{$t('400109')}}</div>
      </div>
      <div class="item">
        <img src="@/assets/img/pay.png" alt />
        <div class="item-title">{{$t('400110')}}</div>
        <div class="item-des">{{$t('400111')}}</div>
      </div>
      <div class="item">
        <img src="@/assets/img/price.png" alt />
        <div class="item-title">{{$t('400112')}}</div>
        <div class="item-des">{{$t('400113')}}</div>
      </div>
      <div class="item">
        <img src="@/assets/img/safety.png" alt />
        <div class="item-title">{{$t('400114')}}</div>
        <div class="item-des">{{$t('400115')}}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      status: 0,
    };
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
@import "@/assets/css/variable.scss";
.advantage-container {
  width: 1200px;
  height: 471px;
  margin: 0 auto 169px;
  .title {
    padding: 96px 0 64px;
    font-size: 32px;
    font-weight: bold;
    @include font-color("font-color");
  }
  .item-list {
    display: flex;
    justify-content: space-between;
    .item {
      width: 286px;
      img {
        width: 286px;
        height: 160px;
      }
      &-title {
        font-size: 23px;
        font-weight: bold;
        margin: 32px 0 16px;
        @include font-color("font-color");
      }
      &-des {
        // color: #40475a;
        font-size: 12px;
        line-height: 18px;
        @include font-color("font-color-2");
      }
    }
  }
}
</style>
